import { useMemo } from 'react'
import useCollection from '../competition-info/submission/hooks/useCollection'

export default function useRatingCriteria(collectionName = 'RatingCriteria') {
  const { documents } = useCollection(collectionName)

  const ratingCriteria = useMemo(() => {
    return (
      (documents &&
        Object.entries(documents)
          .map(([key, doc]) => ({
            id: key,
            ...doc
          }))
          .sort((a, b) => a.position - b.position)) ||
      []
    )
  }, [documents])

  const isExistingItem = id => ratingCriteria.some(item => item.id === id)

  return {
    ratingCriteria,
    isExistingItem
  }
}
